export default __webpack_public_path__ + "static/media/SFTP_image_3.6eda124b.jpg";